import { Examples } from '@/types';

export const SandboxRoutes =
  process.env.NODE_ENV !== 'production'
    ? [
        {
          ...Examples.Sandbox,
          components: {
            default: () =>
              import(
                /* webpackChunkName: "Sandbox" */
                '@/views/examples/Sandbox.vue'
              )
          }
        }
      ]
    : [];
